import React, { Component } from "react";
import { NavBar, Icon, Button, WhiteSpace, WingBlank,TextareaItem,} from "antd-mobile";
import axios from "axios";

export class Tdakak extends Component {
  state ={
    inputval:'',
    inputID:'',
    inputName:'' 
  }
  componentWillMount = () => {
 
  };
  componentDidMount = () => {   
    this.setState({
        inputID:this.props.match.params.id,
        inputName:this.props.match.params.name
      })
  };
  TextareaChange = (e) => {
    this.setState({
      inputval:e
    })
  };
  handleClickTJdd = () => {
    console.log(this.state.inputval,this.state.inputID)
    axios.get('api/patrol/point/punch_in/success', {
     params: {
      pointId:this.state.inputID,
      inspector:this.state.inputval,
          }
        })
        .then( (response)=> {
          console.log(response)
          if(response.status == 200){           
             this.props.history.push("/");
         }
        })
        .catch(function (error) {
          console.log(error);
        });     
  };
  handleClickTIAOZ = () =>{
    this.props.history.push({
      pathname: "/uploadImg/" + this.state.inputID + "/" + this.state.inputName,
    })
  };
  render() {
    return (
      <div className="kakaing">
        <NavBar mode="dark" 
        />
        <h4>巡更点:{this.state.inputName}</h4>
        <TextareaItem
          title="巡更人"
          data-seed="logId"
          onChange={this.TextareaChange.bind(this)}
        />
        <Button type="primary" onClick={this.handleClickTJdd} inline style={{ marginLeft: '70px' }}>合格打卡</Button>
   
        <Button type="ghost"  onClick={this.handleClickTIAOZ} inline style={{ marginLeft: '70px' }} className="am-button-borderfix">异常打卡</Button>

        
      </div>
    );
  }
}

export default Tdakak;
